import { SEARCH } from "../actions";

const initialState = {
  keyword: "",
  searchFetching: false,
  searchData: null,
  totalItems: 0,
  searchError: false,
  searchDataError: null
};

export default (state = initialState, { type, payload, error }) => {
  switch (type) {
    case SEARCH.KEYWORD_CHANGE:
      return { ...state, keyword: payload };

    case SEARCH.SEARCH_ITEM_PENDING:
      return { ...state, searchFetching: true };

    case SEARCH.SEARCH_ITEM_SUCCESS: {
      return {
        ...state,
        searchFetching: false,
        searchData: payload,
        totalItems: payload.length
      };
    }

    case SEARCH.SEARCH_ITEM_FAILED:
      return {
        ...state,
        searchFetching: false,
        searchError: true,
        searchDataError: error,
        searchData: []
      };

    default:
      return state;
  }
};
